import { render, staticRenderFns } from "./ProfileMainDialog.vue?vue&type=template&id=54a019b0&scoped=true&"
import script from "./ProfileMainDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a019b0",
  null
  
)

export default component.exports